"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateChildren = exports.translate = void 0;

var translator_table_1 = require("./translator-table");

function translate(chunk) {
  var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
  var label = chunk.props.label ? "".concat(chunk.props.label, ": ") : "";
  var pattern = "__undefined__";

  if (chunk.tagName) {
    var key = chunk.tagName;
    var Translator = translator_table_1.TranslatorTable[key];
    pattern = new Translator().translate(chunk, actions);
  } else {
    pattern = chunk.rule.name;
  }

  return "".concat(label).concat(pattern);
}

exports.translate = translate;

function translateChildren(chunk, actions) {
  return chunk.children.map(function (child) {
    return translate(child, actions);
  });
}

exports.translateChildren = translateChildren;